import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import styles from 'new/modules/settings/capsules/screens/CapsuleDetailScreen/CapsuleDetailScreen.module.scss';

interface DeleteDialogProps {
  open: boolean;
  isLoading: boolean;
  capsuleTitle: string;
  onClose: () => void;
  onConfirm: () => void;
}

export function DeleteDialog({
  open,
  isLoading,
  capsuleTitle,
  onClose,
  onConfirm,
}: DeleteDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="delete-dialog-title">
      <DialogTitle id="delete-dialog-title">Delete capsule?</DialogTitle>
      <DialogContent>
        <p className={styles.dialogText}>
          This permanently removes <strong>{capsuleTitle}</strong>. This cannot be undone.
        </p>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onConfirm} color="error" variant="contained" disabled={isLoading}>
          {isLoading ? 'Deleting…' : 'Delete'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
